import { forwardRef } from 'react';
import { StyledMain } from './styled';

const Main = forwardRef((props, ref) => <StyledMain ref={ref} {...props} />);

export default Main;
